import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingConfig} from './type-class';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DataService {
  private settingsUrl = environment.api_scheme_host + '/map/settings';
  private settingsAllUrl = environment.api_scheme_host + '/capabilities';

  // public settingsUrl = 'assets/settings.json';

  private chartOptionsSource = new BehaviorSubject<any>(null);
  public chartOptions$ = this.chartOptionsSource.asObservable();

  constructor(private http: HttpClient) {
  }


  getSettings() {
    return this.http.get<SettingConfig>(this.settingsUrl);
    // .pipe(
    // map((resp) => {
    //   console.log(resp);
    //   const modelList = Object.getOwnPropertyNames(resp.models);
    //
    //   const modelListWithParameters = modelList.map((name) => {
    //     return {model: name, parameters: Object.getOwnPropertyNames(resp.models[name])};
    //   });
    //   resp.modelsWithParameters = modelListWithParameters;
    //
    //   return resp;
    //   // const data = this.papa.parse(resp, {header: true, skipEmptyLines: true});
    //   // return data;
    // }));
  }

  checkVersion() {
    return this.http.get<SettingConfig>(this.settingsUrl);
  }

  getPlot(plotUrl) {
    return this.http.get(environment.api_scheme_host + plotUrl, {
      responseType: 'text'
    });
  }


  setChartOptions(staticOptions) {
    this.chartOptionsSource.next(staticOptions);
  }

}
